<template>
    <div class="marketing-portal-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
      <div class="loading-spinner-outer" v-if="logging_into_brandhub">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Logging you in to Brandhub, please wait to be redirected
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Marketing Services in partnership with BrandHub360
                </div>
                <div class="logo">
                    <img src="/images/brandhub-360-header-logo.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Marketing Portal</h1>
                <p>
                    Login to our Brandhub360 portal to order a wide range of professionally designed brochures, point of sale materials, advertising collateral and so much more.
                </p>
                <div>
                    <a class="btn-primary _lg" href="/brandhub-sso" @click="partnerLinkClicked()">
                        <strong>Login to Brandhub360</strong>
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <!--<img src="/images/marketing-landing-page-marketing-portal.png">-->
                <youtube-embed videoId="OXRl33a8sHU"></youtube-embed>
            </div>
            <div class="box-2">
                <p>
                    Artwork templates can be edited instantly with new text and images to produce targeted marketing collateral.  Mailing lists can be added to templates to produce targeted personalised mailings. Business cards can be ordered in seconds by simply entering the details into the appropriate template. Multiple orders can be placed by simply uploading an Excel file and the variable information is instantly imported into the appropriate templates.
                </p>
                <div>
                    <a class="btn-primary-outline _lg" @click.stop="enquiry_box_open = true">
                        Request Login
                    </a>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">BrandHub360 Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like more information on signing up for a Brandhub360 account to access the marketing portal.',
          sending: false,
          logging_into_brandhub: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 10,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Brandhub360 marketing portal enquiry',
                'value': 'Brandhub360 marketing portal enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
          this.logging_into_brandhub = true;
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Brandhub360 Marketing Portal`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Brandhub360 marketing portal partner link clicked',
          'value': 'Brandhub360 marketing portal partner link clicked',
        });
      },
    },
};
</script>
